import { configureStore } from '@reduxjs/toolkit';
import settingsReducer from '../components/SystemSettings/containers/settingsSlice';
import userReducer from '../components/SystemSettings/containers/userSlice';

export default configureStore({
    reducer: {
        settings: settingsReducer,
        userData: userReducer
    }
});
